/* CRO features: exit intent, urgency countdown */
(function () {
  'use strict';

  /* ── Exit Intent (desktop) ─────────────────────────────── */
  var exitModal = document.getElementById('exit-intent-modal');
  var exitClose = document.getElementById('exit-intent-close');
  var exitShown = false;

  if (exitModal && window.innerWidth > 768) {
    var COOKIE_NAME = 'intimum_exit_shown';
    if (!document.cookie.includes(COOKIE_NAME)) {
      document.addEventListener('mouseout', function (e) {
        if (exitShown) return;
        if (e.clientY <= 5 && e.relatedTarget === null) {
          exitShown = true;
          exitModal.classList.add('is-active');
          document.body.style.overflow = 'hidden';

          var d = new Date();
          d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
          document.cookie = COOKIE_NAME + '=1;expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
        }
      });
    }

    exitClose?.addEventListener('click', function () {
      exitModal.classList.remove('is-active');
      document.body.style.overflow = '';
    });

    exitModal.addEventListener('click', function (e) {
      if (e.target === exitModal) {
        exitModal.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Countdown Timer ───────────────────────────────────── */
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var endDate = new Date(el.dataset.countdown);

    function updateCountdown() {
      var now = new Date();
      var diff = endDate - now;

      if (diff <= 0) {
        el.textContent = 'Oferta terminada';
        return;
      }

      var hours = Math.floor(diff / (1000 * 60 * 60));
      var mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secs = Math.floor((diff % (1000 * 60)) / 1000);

      el.innerHTML =
        '<span class="countdown__unit">' + String(hours).padStart(2, '0') + '<small>h</small></span>' +
        '<span class="countdown__sep">:</span>' +
        '<span class="countdown__unit">' + String(mins).padStart(2, '0') + '<small>m</small></span>' +
        '<span class="countdown__sep">:</span>' +
        '<span class="countdown__unit">' + String(secs).padStart(2, '0') + '<small>s</small></span>';
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  });
})();
